export const actions = {
  READ: 'read',
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  MANAGE: 'MANAGE',
};

export const allSubjects = {
  AUDIT: 'audit',
  ACCOUNT_MANAGER: 'account manager',
  CUSTOMER_USERS: 'customer users',
  CUSTOMER_EXTERNAL_USERS: 'customer external users internal',
  CUSTOMER_LICENSE: 'customer license',
  USER: 'user',
  ROLE: 'role',
  ROLE_USER: 'role user',
  LICENSE_USERS: 'license users',
  LICENSE_ROLES: 'license roles',
  CUSTOMER: 'customer',
  API_KEYS: 'API keys',
  STATISTICS: 'statistics'
};

// Internal subjects will effect rules for any customer
// Example: INTERNAL_AUDIT subject with READ action will give access to view any audit of any customer
export const internalSubjects = {
  IDENTIFICATIONS_INTERNAL: 'identifications internal',
  ALL: 'all',
  LOGS: 'logs',
  IDP_USERS_INTERNAL: 'IdP users',
  ACCOUNT_REPRESENTATIVE_INTERNAL: 'account representative',
  ORGANIZATION_INTERNAL: 'organization',
  AUDIT_INTERNAL: 'audit internal',
  APPLICATION_INTERNAL: 'application internal',
  ACCOUNT_MANAGER_INTERNAL: 'account manager internal',
  CUSTOMER_USERS_INTERNAL: 'customer users internal',
  OLIASOFT_USERS_INTERNAL: 'oliasoft users internal',
  CUSTOMER_EXTERNAL_USERS_INTERNAL: 'customer external users internal',
  CUSTOMER_LICENSE_INTERNAL: 'customer license internal',
  ROLE_INTERNAL: 'role internal',
  PRODUCT_INTERNAL: 'product internal',
  PERMISSIONS_INTERNAL: 'permissions internal',
  LICENSE_USERS_INTERNAL: 'license users internal',
  LICENSE_ROLES_INTERNAL: 'license roles internal',
  ROLE_USER_INTERNAL: 'role user internal',
  SUBJECTS_INTERNAL: 'subjects internal',
  LICENSE_INTERNAL: 'license internal',
  CUSTOMER_INTERNAL: 'customer internal',
  API_KEYS_INTERNAL: 'API keys internal',
  ROLE_SYNCHRONIZATION_INTERNAL: 'role synchronization internal',
  EXTERNAL_IDENTIFICATIONS_INTERNAL: 'external identifications internal',
  CUSTOMER_EXTERNAL_IDENTIFICATIONS_INTERNAL: 'customer external identifications internal',
  EXTERNAL_EMAILS_INTERNAL: 'external emails internal',
  CUSTOMER_HARD_DELETE_INTERNAL: 'customer hard delete internal',
  LOCAL_STRATEGY_INTERNAL: 'local strategy internal',
  MFA_INTERNAL: 'multi-factor authentication',
  EXTERNAL_USERS_REQUESTS_INTERNAL: 'external users requests internal',
  FEATURE_FLAGS_INTERNAL: 'features flags internal',
  FEATURE_FLAGS: 'features flags internal',
  SURVEYS_INTERNAL: 'surveys internal',
  QUESTIONS_INTERNAL: 'questions internal',
  USER_SURVEY_INTERNAL: 'user survey internal',
  QUESTION_ANSWER_INTERNAL: 'question answer internal',
  RELEASE_NOTES_INTERNAL: 'release notes internal',
  SUPPORT_INTERNAL: 'support',
  ACCESS_BGGM_MODEL_INTERNAL: 'BGGM',
  ACCESS_AI_FEATURES_INTERNAL: 'AI'
};
